export const pageId = 'mfaPromotePage';
